import "./style.css";

/** Selector de hora simple: dos selects nativos HH (00–23) y MM (00–59).
 * Toma value "HH:MM" y emite el mismo formato. Sin popper ni reloj —
 * dropdown nativo del browser, predecible y rápido. */
export default function HourField({
  value,              // "HH:MM" o null
  onChange,
  disabled = false,
  accent,             // "yellow" | "blue"
  maxTime,            // "HH:MM" — límite superior inclusive (ej. hora actual hoy)
  minTime,            // "HH:MM" — límite inferior inclusive
  placeholder,        // (no usado — se mantiene para compat con la API previa)
}) {
  const [hh, mm] = (value && /^\d{2}:\d{2}$/.test(value))
    ? value.split(":")
    : ["", ""];

  // Parseo de bounds a minutos totales para comparar fácil.
  const toMin = (s) => {
    if (!s || !/^\d{2}:\d{2}$/.test(s)) return null;
    const [h, m] = s.split(":").map((n) => parseInt(n, 10));
    return h * 60 + m;
  };
  const lo = toMin(minTime);
  const hi = toMin(maxTime);

  const emit = (newHH, newMM) => {
    onChange(`${newHH}:${newMM}`);
  };

  return (
    <div className={`hour-field hour-field--${accent || "yellow"}${disabled ? " hour-field--disabled" : ""}`}>
      <select
        className="hour-field__sel"
        disabled={disabled}
        value={hh}
        onChange={(e) => {
          const newHH = e.target.value;
          // Si MM no está set, defaulteamos a "00".
          let newMM = mm || "00";
          // Clamp al rango: si el (HH:MM) cae fuera, ajustamos MM.
          const total = parseInt(newHH, 10) * 60 + parseInt(newMM, 10);
          if (hi != null && total > hi) {
            newMM = String(hi % 60).padStart(2, "0");
          } else if (lo != null && total < lo) {
            newMM = String(lo % 60).padStart(2, "0");
          }
          emit(newHH, newMM);
        }}
        aria-label="Hora"
      >
        {!hh && <option value="" disabled>HH</option>}
        {[...Array(24)].map((_, i) => {
          const v = String(i).padStart(2, "0");
          // Deshabilitar horas que no caen en [lo..hi] aunque sea con MM=0.
          const minOfH = i * 60;
          const maxOfH = i * 60 + 59;
          const out = (hi != null && minOfH > hi) || (lo != null && maxOfH < lo);
          return <option key={v} value={v} disabled={out}>{v}</option>;
        })}
      </select>
      <span className="hour-field__sep">:</span>
      <select
        className="hour-field__sel"
        disabled={disabled || !hh}
        value={mm}
        onChange={(e) => emit(hh || "00", e.target.value)}
        aria-label="Minuto"
      >
        {!mm && <option value="" disabled>MM</option>}
        {[...Array(60)].map((_, i) => {
          const v = String(i).padStart(2, "0");
          const total = (parseInt(hh || "0", 10)) * 60 + i;
          const out = (hi != null && total > hi) || (lo != null && total < lo);
          return <option key={v} value={v} disabled={out}>{v}</option>;
        })}
      </select>
    </div>
  );
}
